module.exports = __webpack_public_path__ + "img/mappa_tragitto.ec9a12ea.png";